import React from 'react';
import { contact } from '../../content/site';
import { ArrowRight } from '../Common/Icons';

const CtaBand = ({
  title = 'Ready to start your project?',
  text = 'Tell us what you are building and we will come back to you with a plan, a programme and a price.',
}) => (
  <section className="cta-band">
    <div className="container cta-band__inner">
      <div>
        <h2 className="cta-band__title">{title}</h2>
        <p className="cta-band__text">{text}</p>
      </div>

      <a href={`mailto:${contact.email}`} className="btn">
        Request a Quote
        <ArrowRight />
      </a>
    </div>
  </section>
);

export default CtaBand;
